import { defineComponent as _defineComponent } from 'vue'
import { useNotificationStore } from "@/stores/notification";


export default /*#__PURE__*/_defineComponent({
  __name: 'TheNotification',
  setup(__props) {

const notificationStore = useNotificationStore();

return { __sfc: true,notificationStore }
}

})